import React, { useState, useEffect } from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table,
    TableHead,
    TableBody,
    TableCell,
    Select,
    IconButton,
    Tooltip,
    Typography as MuiTypography
} from "@material-ui/core";
import AdminEventService from "./Locality/Service/adminEventService";
import CityService from "./Locality/Service/cityService";
import CategoryService from "./Locality/Service/categoryService";

import requests from "./Locality/Service/httpService";
import * as Yup from 'yup';
import { Typography } from "../../components/Wrappers/Wrappers";
import TablePagination from '@material-ui/core/TablePagination';
import { Grid, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "rgb(255, 107, 129)",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    tableOverflow: {
        overflowX: 'auto',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
}));

export default function AdminEvent() {
    const tableHeaders = ['City', 'Event Name', 'Image', 'Category', 'Venue', 'Location', 'From Date', 'To Date', 'From Time', 'To Time', 'Status', 'Actions'];
    const classes = useStyles();
    const [adminEventList, setAdminEventList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
    const [adminEventToDelete, setAdminEventToDelete] = React.useState(null);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(5);
    const [eventImage, setEventImage] = React.useState('');
    const [cityList, setCityList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [filterCityId, setFilterCityId] = useState('');
    const [filterCategoryId, setFilterCategoryId] = useState('');
    const [adminEvent, setAdminEvent] = useState({
        cityId: '',
        eventName: '',
        eventImage: '',
        fromDate: '',
        fromTime: '12:00 AM',
        fromAmPm: 'AM',
        toDate: '',
        toTime: '12:00 AM',
        toAmPm: 'AM',
        venue: '',
        categoryId: '',
        locationLink: '',
        specialInstructions: '',
        status: 'active',
    });

    const validationSchema = Yup.object().shape({
        cityId: Yup.string().required('City is required'),
        eventName: Yup.string().required('Event Name is required'),
        eventImage: Yup.string(),
        fromDate: Yup.date().required('From Date is required'),
        fromTime: Yup.string().required('From Time is required'),
        toDate: Yup.date().required('To Date is required'),
        toTime: Yup.string().required('To Time is required'),
        venue: Yup.string().required('Venue is required'),
        categoryId: Yup.string(),
        specialInstructions: Yup.string(),
        status: Yup.string().required('Status is required'),
    });

    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    };

    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    };

    useEffect(() => {
        getCityList();
        getCategoryList();
        return () => {
            setAdminEventList([]);
        };
    }, []);

    useEffect(() => {
        // Load events when component mounts or filters change
        getAdminEventList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterCityId, filterCategoryId]);

    const getCityList = () => {
        // Get all cities added by admin (both active and inactive)
        CityService.getAllCity().then((res) => {
            setCityList(res);
        }).catch((err) => {
            console.error(err);
            // Fallback to getCity if getAllCity fails
            CityService.getCity({}).then((res) => {
                setCityList(res);
            }).catch((err2) => {
                console.error(err2);
            });
        });
    };

    const getCategoryList = () => {
        CategoryService.getCategory({ status: true }).then((res) => {
            setCategoryList(res);
        }).catch((err) => {
            console.error(err);
        });
    };

    const getAdminEventList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const profileId = userDetails.role === "admin" ? null : userDetails.profileId;
        
        const filterParams = { profileRegistrationId: profileId };
        
        // Add city filter if selected
        if (filterCityId) {
            filterParams.cityId = filterCityId;
        }
        
        // Add category filter if selected
        if (filterCategoryId) {
            filterParams.categoryId = filterCategoryId;
        }
        
        AdminEventService.getAdminEvent(filterParams).then((res) => {
            setAdminEventList(res);
            // Reset pagination when filters change
            setpg(0);
        }).catch((err) => {
            console.error(err);
        });
    };

    const handleOpen = () => {
        setAdminEvent({
            cityId: '',
            eventName: '',
            eventImage: '',
            fromDate: '',
            fromTime: '12:00 AM',
            fromAmPm: 'AM',
            toDate: '',
            toTime: '12:00 AM',
            toAmPm: 'AM',
            venue: '',
            categoryId: '',
            locationLink: '',
            specialInstructions: '',
            status: 'active',
        });
        setEventImage('');
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setAdminEvent({
            cityId: '',
            eventName: '',
            eventImage: '',
            fromDate: '',
            fromTime: '12:00 AM',
            fromAmPm: 'AM',
            toDate: '',
            toTime: '12:00 AM',
            toAmPm: 'AM',
            venue: '',
            categoryId: '',
            locationLink: '',
            specialInstructions: '',
            status: 'active',
        });
        setEventImage('');
    };

    const uploadEventImage = (evt) => {
        const file = evt.target.files[0];
        if (!file) {
            alert("Please select an image to upload");
            return;
        }
        const formData = new FormData();
        formData.append('image', file);
        formData.append('imageName', file.name);
        
        AdminEventService.uploadImage(formData).then((res) => {
            // The uploadRoutes returns the URL directly in res.url
            if (res.url) {
                setEventImage(res.url);
            } else {
                alert("Image uploaded but URL not received");
            }
        }).catch((err) => {
            alert("Error uploading event image: " + (err.response?.data?.message || err.message));
        });
    };

    const removeEventImage = () => {
        setEventImage('');
        // Also clear the existing image from adminEvent state when editing
        if (adminEvent._id) {
            setAdminEvent({
                ...adminEvent,
                eventImage: ''
            });
        }
        // Reset the file input
        const fileInput = document.getElementById('event-image-upload');
        if (fileInput) {
            fileInput.value = '';
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    };

    const formatTime = (timeString) => {
        if (!timeString) return 'N/A';
        if (timeString.includes(':')) {
            const timeParts = timeString.split(':');
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1] || '00';
            
            // Handle 24-hour format conversion
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            if (hours === 0) {
                hours = 12; // 12 AM for midnight, 12 PM for noon
            }
            
            return `${hours}:${minutes} ${ampm}`;
        }
        return timeString;
    };

    // Convert 24-hour format to 12-hour format for display
    const convertTo12Hour = (time24) => {
        if (!time24) return '';
        if (time24.includes(':')) {
            const [hours, minutes] = time24.split(':');
            const hour24 = parseInt(hours, 10);
            const ampm = hour24 >= 12 ? 'PM' : 'AM';
            let hour12 = hour24 % 12;
            if (hour12 === 0) hour12 = 12;
            return `${hour12}:${minutes} ${ampm}`;
        }
        return time24;
    };

    // Convert 12-hour format to 24-hour format for storage
    const convertTo24Hour = (time12) => {
        if (!time12) return '';
        const match = time12.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
        if (!match) return time12; // Return as is if format doesn't match
        
        let hours = parseInt(match[1], 10);
        const minutes = match[2];
        const ampm = match[3].toUpperCase();
        
        if (ampm === 'PM' && hours !== 12) {
            hours += 12;
        } else if (ampm === 'AM' && hours === 12) {
            hours = 0;
        }
        
        return `${String(hours).padStart(2, '0')}:${minutes}`;
    };

    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Parse time string (HH:MM AM/PM) and AM/PM to get hour, minute, and AM/PM
    const parseTime12Hour = (timeString) => {
        if (!timeString || timeString.trim() === '') {
            return { hour: '12', minute: '00', ampm: 'AM' };
        }
        // Check if time is in 12-hour format (e.g., "9:30 AM")
        const match = timeString.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
        if (match) {
            return {
                hour: match[1],
                minute: match[2],
                ampm: match[3].toUpperCase()
            };
        }
        // If time is in 24-hour format (e.g., "09:30"), convert it
        if (timeString.includes(':')) {
            const [hours, minutes] = timeString.split(':');
            const hour24 = parseInt(hours, 10);
            if (!isNaN(hour24)) {
                const ampm = hour24 >= 12 ? 'PM' : 'AM';
                let hour12 = hour24 % 12;
                if (hour12 === 0) hour12 = 12;
                return {
                    hour: String(hour12),
                    minute: minutes || '00',
                    ampm: ampm
                };
            }
        }
        return { hour: '12', minute: '00', ampm: 'AM' };
    };

    // Combine hour, minute, and AM/PM into 12-hour time string
    const combineTime12Hour = (hour, minute, ampm) => {
        if (!hour || !minute) return '';
        return `${hour}:${minute} ${ampm}`;
    };

    // Handle datetime change for 12-hour format
    const handleDateTimeChange = (fieldPrefix, dateValue, timeValue, ampmValue) => {
        const dateField = `${fieldPrefix}Date`;
        const timeField = `${fieldPrefix}Time`;
        const ampmField = `${fieldPrefix}AmPm`;
        
        if (dateValue !== undefined) {
            formik.setFieldValue(dateField, dateValue);
        }
        if (timeValue !== undefined) {
            formik.setFieldValue(timeField, timeValue);
        }
        if (ampmValue !== undefined) {
            formik.setFieldValue(ampmField, ampmValue);
            // Update time field with new AM/PM
            const currentTime = formik.values[timeField] || '12:00 AM';
            const parsed = parseTime12Hour(currentTime);
            const newTime = combineTime12Hour(parsed.hour, parsed.minute, ampmValue);
            formik.setFieldValue(timeField, newTime);
        }
    };

    const editAdminEvent = (eventItem) => {
        // Parse time to get hour, minute, and AM/PM
        const fromTimeParsed = parseTime12Hour(eventItem.fromTime || '');
        const toTimeParsed = parseTime12Hour(eventItem.toTime || '');
        
        const obj = {
            _id: eventItem._id,
            cityId: eventItem.cityId?._id || eventItem.cityId || '',
            eventName: eventItem.eventName || '',
            eventImage: eventItem.eventImage || '',
            fromDate: formatDateForInput(eventItem.fromDate),
            fromTime: combineTime12Hour(fromTimeParsed.hour, fromTimeParsed.minute, fromTimeParsed.ampm),
            fromAmPm: fromTimeParsed.ampm,
            toDate: formatDateForInput(eventItem.toDate),
            toTime: combineTime12Hour(toTimeParsed.hour, toTimeParsed.minute, toTimeParsed.ampm),
            toAmPm: toTimeParsed.ampm,
            venue: eventItem.venue || '',
            categoryId: eventItem.categoryId?._id || eventItem.categoryId || '',
            locationLink: eventItem.locationLink || '',
            specialInstructions: eventItem.specialInstructions || '',
            status: eventItem.status || 'active',
        };
        setAdminEvent(obj);
        setEventImage(eventItem.eventImage || '');
        setOpen(true);
    };

    const handleDeleteClick = (eventItem) => {
        setAdminEventToDelete(eventItem);
        setDeleteDialogOpen(true);
    };

    const handleDeleteConfirm = () => {
        if (adminEventToDelete) {
            AdminEventService.deleteAdminEvent(adminEventToDelete).then((res) => {
                getAdminEventList();
                setDeleteDialogOpen(false);
                setAdminEventToDelete(null);
                alert("Admin Event Deleted Successfully.");
            }).catch((err) => {
                alert("Error deleting admin event: " + (err.response?.data?.message || err.message));
            });
        }
    };

    const handleDeleteCancel = () => {
        setDeleteDialogOpen(false);
        setAdminEventToDelete(null);
    };

    const formik = useFormik({
        initialValues: adminEvent,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.profileRegistrationId = userDetails.profileId;
            
            // Handle event image
            values.eventImage = eventImage || adminEvent.eventImage || '';
            
            // Handle cityId - ensure it's sent
            if (!values.cityId) {
                delete values.cityId;
            }
            
            // Handle categoryId - convert empty string to null if optional
            if (values.categoryId === '') {
                values.categoryId = null;
            }
            
            // Convert date strings to Date objects
            if (values.fromDate) {
                values.fromDate = new Date(values.fromDate);
            }
            if (values.toDate) {
                values.toDate = new Date(values.toDate);
            }

            // Convert 12-hour format times to 24-hour format for storage
            if (values.fromTime) {
                values.fromTime = convertTo24Hour(values.fromTime);
            }
            if (values.toTime) {
                values.toTime = convertTo24Hour(values.toTime);
            }
            
            // Remove AM/PM fields as they're not needed in backend
            delete values.fromAmPm;
            delete values.toAmPm;

            // Handle locationLink - convert empty string to null
            if (values.locationLink === '') {
                values.locationLink = null;
            }

            if (adminEvent._id) {
                values._id = adminEvent._id;
                AdminEventService.updateAdminEvent(values).then((res) => {
                    handleClose();
                    getAdminEventList();
                    resetForm();
                    setAdminEvent({
                        cityId: '',
                        eventName: '',
                        eventImage: '',
                        fromDate: '',
                        fromTime: '12:00 AM',
                        fromAmPm: 'AM',
                        toDate: '',
                        toTime: '12:00 AM',
                        toAmPm: 'AM',
                        venue: '',
                        categoryId: '',
                        locationLink: '',
                        specialInstructions: '',
                        status: 'active',
                    });
                    setEventImage('');
                    alert("Admin Event Updated Successfully.");
                }).catch((err) => {
                    alert("Error updating admin event: " + (err.response?.data?.message || err.message));
                });
            } else {
                AdminEventService.createAdminEvent(values).then((res) => {
                    getAdminEventList();
                    resetForm();
                    handleClose();
                    setAdminEvent({
                        cityId: '',
                        eventName: '',
                        eventImage: '',
                        fromDate: '',
                        fromTime: '12:00 AM',
                        fromAmPm: 'AM',
                        toDate: '',
                        toTime: '12:00 AM',
                        toAmPm: 'AM',
                        venue: '',
                        categoryId: '',
                        locationLink: '',
                        specialInstructions: '',
                        status: 'active',
                    });
                    setEventImage('');
                    alert("Admin Event Added Successfully.");
                }).catch((err) => {
                    alert(err.response?.data?.message || "Error adding admin event");
                });
            }
        },
    });

    return (
        <>
            <PageTitle title="Admin Events" button={<Button
                variant="contained" onClick={handleOpen}
                size="medium"
                color="secondary" style={{ backgroundColor: 'rgb(112, 57, 177)' }}> Add Admin Event
            </Button>} />
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    {/* Filter Section */}
                    <Widget title="Filters" upperTitle>
                        <Grid container spacing={2} style={{ padding: '16px' }}>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth variant="outlined" margin="dense">
                                    <InputLabel id="filter-city-label">Filter by City</InputLabel>
                                    <Select
                                        labelId="filter-city-label"
                                        id="filterCityId"
                                        value={filterCityId}
                                        onChange={(e) => setFilterCityId(e.target.value)}
                                        label="Filter by City"
                                    >
                                        <MenuItem value="">
                                            <em>All Cities</em>
                                        </MenuItem>
                                        {cityList.map((city) => (
                                            <MenuItem key={city._id} value={city._id}>
                                                {city.city}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth variant="outlined" margin="dense">
                                    <InputLabel id="filter-category-label">Filter by Category</InputLabel>
                                    <Select
                                        labelId="filter-category-label"
                                        id="filterCategoryId"
                                        value={filterCategoryId}
                                        onChange={(e) => setFilterCategoryId(e.target.value)}
                                        label="Filter by Category"
                                    >
                                        <MenuItem value="">
                                            <em>All Categories</em>
                                        </MenuItem>
                                        {categoryList.map((category) => (
                                            <MenuItem key={category._id} value={category._id}>
                                                {category.category}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4} style={{ display: 'flex', alignItems: 'center' }}>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        setFilterCityId('');
                                        setFilterCategoryId('');
                                    }}
                                    style={{ marginTop: '8px' }}
                                    disabled={!filterCityId && !filterCategoryId}
                                >
                                    Clear Filters
                                </Button>
                            </Grid>
                        </Grid>
                    </Widget>
                </Grid>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                        <Table className="mb-0">
                            <TableHead>
                                <TableRow>
                                    {tableHeaders.map(key => (
                                        <StyledTableCell key={key}>{key}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {adminEventList.slice(pg * rpg, pg * rpg + rpg).map((eventItem) => (
                                    <TableRow key={eventItem._id}>
                                        <TableCell className="pl-3 fw-normal">
                                            {eventItem.cityId?.city || eventItem.cityId || '-'}
                                        </TableCell>
                                        <TableCell className="pl-3 fw-normal">{eventItem.eventName}</TableCell>
                                        <TableCell className="pl-3 fw-normal">
                                            {eventItem.eventImage ? (
                                                <img 
                                                    src={eventItem.eventImage} 
                                                    alt={eventItem.eventName || 'Event'} 
                                                    style={{ 
                                                        width: '60px', 
                                                        height: '60px', 
                                                        objectFit: 'cover',
                                                        borderRadius: '4px',
                                                        border: '1px solid #ddd',
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => window.open(eventItem.eventImage, '_blank')}
                                                    onError={(e) => {
                                                        e.target.style.display = 'none';
                                                    }}
                                                />
                                            ) : (
                                                <span style={{ color: '#999', fontSize: '12px' }}>No Image</span>
                                            )}
                                        </TableCell>
                                        <TableCell className="pl-3 fw-normal">
                                            {eventItem.categoryId?.category || eventItem.categoryId || '-'}
                                        </TableCell>
                                        <TableCell className="pl-3 fw-normal">{eventItem.venue}</TableCell>
                                        <TableCell className="pl-3 fw-normal">
                                            {eventItem.locationLink ? (
                                                <a
                                                    href={eventItem.locationLink}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        color: '#1976d2',
                                                        textDecoration: 'none',
                                                        cursor: 'pointer',
                                                        fontWeight: '500'
                                                    }}
                                                    onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                                                    onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                                                >
                                                    Open in Google Map
                                                </a>
                                            ) : (
                                                <span style={{ color: '#999', fontSize: '12px' }}>-</span>
                                            )}
                                        </TableCell>
                                        <TableCell className="pl-3 fw-normal">{formatDate(eventItem.fromDate)}</TableCell>
                                        <TableCell className="pl-3 fw-normal">{formatDate(eventItem.toDate)}</TableCell>
                                        <TableCell className="pl-3 fw-normal">{formatTime(eventItem.fromTime)}</TableCell>
                                        <TableCell className="pl-3 fw-normal">{formatTime(eventItem.toTime)}</TableCell>
                                        <TableCell className="pl-3 fw-normal">
                                            <span style={{
                                                padding: '4px 8px',
                                                borderRadius: '4px',
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                textTransform: 'capitalize',
                                                backgroundColor: eventItem.status === 'active' ? '#4caf50' : '#f44336',
                                                color: 'white'
                                            }}>
                                                {eventItem.status}
                                            </span>
                                        </TableCell>
                                        <TableCell className="pl-3 fw-normal">
                                            <Tooltip title="Edit Admin Event">
                                                <IconButton 
                                                    size="small" 
                                                    onClick={() => editAdminEvent(eventItem)}
                                                    style={{ color: '#1976d2' }}
                                                >
                                                    <EditIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Delete Admin Event">
                                                <IconButton 
                                                    size="small" 
                                                    onClick={() => handleDeleteClick(eventItem)}
                                                    style={{ color: '#d32f2f' }}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            count={adminEventList.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
            <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
                <DialogTitle>{adminEvent._id ? 'Edit Admin Event' : 'Add Admin Event'}</DialogTitle>
                <form onSubmit={formik.handleSubmit}>
                    <DialogContent>
                        <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id="eventName"
                                    name="eventName"
                                    label="Event Name"
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={formik.handleChange}
                                    value={formik.values.eventName}
                                    error={formik.touched.eventName && Boolean(formik.errors.eventName)}
                                    helperText={formik.touched.eventName && formik.errors.eventName}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth variant="outlined" margin="dense">
                                    <InputLabel id="city-select-label">City</InputLabel>
                                    <Select
                                        labelId="city-select-label"
                                        id="cityId"
                                        name="cityId"
                                        value={formik.values.cityId}
                                        onChange={formik.handleChange}
                                        label="City"
                                        error={formik.touched.cityId && Boolean(formik.errors.cityId)}
                                    >
                                        <MenuItem value="">
                                            <em>Select City</em>
                                        </MenuItem>
                                        {cityList.map((city) => (
                                            <MenuItem key={city._id} value={city._id}>
                                                {city.city}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {formik.touched.cityId && formik.errors.cityId && (
                                        <Typography size="sm" color="error" style={{ marginTop: 8, marginLeft: 14 }}>
                                            {formik.errors.cityId}
                                        </Typography>
                                    )}
                                </FormControl>
                            </Grid>
                           
                            <Grid item xs={12}>
                                <MuiTypography variant="body2" style={{ marginBottom: 8, fontWeight: 'bold' }}>
                                    Event Image
                                </MuiTypography>
                                <input
                                    accept="image/*"
                                    style={{ display: 'none' }}
                                    id="event-image-upload"
                                    type="file"
                                    onChange={uploadEventImage}
                                />
                                <label htmlFor="event-image-upload">
                                    <Button 
                                        variant="outlined" 
                                        component="span" 
                                        fullWidth 
                                        style={{ marginBottom: 8 }}
                                    >
                                        Upload Event Image
                                    </Button>
                                </label>
                                
                                {/* Show uploaded image with remove button */}
                                {eventImage && (
                                    <div style={{ 
                                        marginTop: 8, 
                                        position: 'relative',
                                        display: 'inline-block',
                                        width: '100%'
                                    }}>
                                        <div style={{
                                            position: 'relative',
                                            display: 'inline-block',
                                            width: '100%',
                                            maxWidth: '400px'
                                        }}>
                                            <img 
                                                src={eventImage} 
                                                alt="Event preview" 
                                                style={{ 
                                                    width: '100%',
                                                    maxHeight: '300px', 
                                                    objectFit: 'contain',
                                                    border: '2px solid #ddd',
                                                    borderRadius: '8px',
                                                    padding: '8px',
                                                    backgroundColor: '#f5f5f5'
                                                }} 
                                            />
                                            <Tooltip title="Remove Image">
                                                <IconButton
                                                    onClick={removeEventImage}
                                                    style={{
                                                        position: 'absolute',
                                                        top: 8,
                                                        right: 8,
                                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                        color: '#d32f2f',
                                                        padding: '4px',
                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                    }}
                                                    size="small"
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                        <MuiTypography variant="caption" color="textSecondary" style={{ display: 'block', marginTop: 4 }}>
                                            Image uploaded successfully. Click the X button to remove.
                                        </MuiTypography>
                                    </div>
                                )}
                                
                                {/* Show existing image when editing (if no new image uploaded) */}
                                {!eventImage && adminEvent.eventImage && (
                                    <div style={{ 
                                        marginTop: 8, 
                                        position: 'relative',
                                        display: 'inline-block',
                                        width: '100%'
                                    }}>
                                        <MuiTypography variant="caption" color="textSecondary" style={{ display: 'block', marginBottom: 4 }}>
                                            Current Image:
                                        </MuiTypography>
                                        <div style={{
                                            position: 'relative',
                                            display: 'inline-block',
                                            width: '100%',
                                            maxWidth: '400px'
                                        }}>
                                            <img 
                                                src={adminEvent.eventImage} 
                                                alt="Current event" 
                                                style={{ 
                                                    width: '100%',
                                                    maxHeight: '300px', 
                                                    objectFit: 'contain',
                                                    border: '2px solid #ddd',
                                                    borderRadius: '8px',
                                                    padding: '8px',
                                                    backgroundColor: '#f5f5f5'
                                                }} 
                                            />
                                            <Tooltip title="Remove Image">
                                                <IconButton
                                                    onClick={removeEventImage}
                                                    style={{
                                                        position: 'absolute',
                                                        top: 8,
                                                        right: 8,
                                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                        color: '#d32f2f',
                                                        padding: '4px',
                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                    }}
                                                    size="small"
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    </div>
                                )}
                            </Grid>
                            {/* From Date & Time with 12-hour format */}
                            <Grid item xs={12} sm={6}>
                                <MuiTypography variant="body2" style={{ marginBottom: 8, fontWeight: 'bold' }}>
                                    From Date & Time
                                </MuiTypography>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            label="Date"
                                            type="date"
                                            variant="outlined"
                                            margin="dense"
                                            onChange={(e) => handleDateTimeChange('from', e.target.value, undefined, undefined)}
                                            value={formik.values.fromDate}
                                            error={formik.touched.fromDate && Boolean(formik.errors.fromDate)}
                                            helperText={formik.touched.fromDate && formik.errors.fromDate}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={4} sm={2}>
                                        <FormControl fullWidth variant="outlined" margin="dense">
                                            <InputLabel id="from-hour-label">Hour</InputLabel>
                                            <Select
                                                labelId="from-hour-label"
                                                id="fromHour"
                                                value={parseTime12Hour(formik.values.fromTime || '').hour}
                                                onChange={(e) => {
                                                    const parsed = parseTime12Hour(formik.values.fromTime || '');
                                                    const newTime = combineTime12Hour(e.target.value, parsed.minute, parsed.ampm);
                                                    handleDateTimeChange('from', undefined, newTime, undefined);
                                                }}
                                                label="Hour"
                                            >
                                                {Array.from({ length: 12 }, (_, i) => i + 1).map(hour => (
                                                    <MenuItem key={hour} value={String(hour)}>{hour}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={4} sm={2}>
                                        <FormControl fullWidth variant="outlined" margin="dense">
                                            <InputLabel id="from-minute-label">Min</InputLabel>
                                            <Select
                                                labelId="from-minute-label"
                                                id="fromMinute"
                                                value={parseTime12Hour(formik.values.fromTime || '').minute}
                                                onChange={(e) => {
                                                    const parsed = parseTime12Hour(formik.values.fromTime || '');
                                                    const newTime = combineTime12Hour(parsed.hour, e.target.value, parsed.ampm);
                                                    handleDateTimeChange('from', undefined, newTime, undefined);
                                                }}
                                                label="Min"
                                            >
                                                {Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0')).map(minute => (
                                                    <MenuItem key={minute} value={minute}>{minute}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={4} sm={2}>
                                        <FormControl fullWidth variant="outlined" margin="dense">
                                            <InputLabel id="from-ampm-label">AM/PM</InputLabel>
                                            <Select
                                                labelId="from-ampm-label"
                                                id="fromAmPm"
                                                value={formik.values.fromAmPm || 'AM'}
                                                onChange={(e) => handleDateTimeChange('from', undefined, undefined, e.target.value)}
                                                label="AM/PM"
                                            >
                                                <MenuItem value="AM">AM</MenuItem>
                                                <MenuItem value="PM">PM</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                {formik.touched.fromDate && formik.errors.fromDate && (
                                    <Typography size="sm" color="error" style={{ marginTop: 4, marginLeft: 14 }}>
                                        {formik.errors.fromDate}
                                    </Typography>
                                )}
                                {formik.touched.fromTime && formik.errors.fromTime && (
                                    <Typography size="sm" color="error" style={{ marginTop: 4, marginLeft: 14 }}>
                                        {formik.errors.fromTime}
                                    </Typography>
                                )}
                            </Grid>
                            
                            {/* To Date & Time with 12-hour format */}
                            <Grid item xs={12} sm={6}>
                                <MuiTypography variant="body2" style={{ marginBottom: 8, fontWeight: 'bold' }}>
                                    To Date & Time
                                </MuiTypography>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            label="Date"
                                            type="date"
                                            variant="outlined"
                                            margin="dense"
                                            onChange={(e) => handleDateTimeChange('to', e.target.value, undefined, undefined)}
                                            value={formik.values.toDate}
                                            error={formik.touched.toDate && Boolean(formik.errors.toDate)}
                                            helperText={formik.touched.toDate && formik.errors.toDate}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={4} sm={2}>
                                        <FormControl fullWidth variant="outlined" margin="dense">
                                            <InputLabel id="to-hour-label">Hour</InputLabel>
                                            <Select
                                                labelId="to-hour-label"
                                                id="toHour"
                                                value={parseTime12Hour(formik.values.toTime || '').hour}
                                                onChange={(e) => {
                                                    const parsed = parseTime12Hour(formik.values.toTime || '');
                                                    const newTime = combineTime12Hour(e.target.value, parsed.minute, parsed.ampm);
                                                    handleDateTimeChange('to', undefined, newTime, undefined);
                                                }}
                                                label="Hour"
                                            >
                                                {Array.from({ length: 12 }, (_, i) => i + 1).map(hour => (
                                                    <MenuItem key={hour} value={String(hour)}>{hour}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={4} sm={2}>
                                        <FormControl fullWidth variant="outlined" margin="dense">
                                            <InputLabel id="to-minute-label">Min</InputLabel>
                                            <Select
                                                labelId="to-minute-label"
                                                id="toMinute"
                                                value={parseTime12Hour(formik.values.toTime || '').minute}
                                                onChange={(e) => {
                                                    const parsed = parseTime12Hour(formik.values.toTime || '');
                                                    const newTime = combineTime12Hour(parsed.hour, e.target.value, parsed.ampm);
                                                    handleDateTimeChange('to', undefined, newTime, undefined);
                                                }}
                                                label="Min"
                                            >
                                                {Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0')).map(minute => (
                                                    <MenuItem key={minute} value={minute}>{minute}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={4} sm={2}>
                                        <FormControl fullWidth variant="outlined" margin="dense">
                                            <InputLabel id="to-ampm-label">AM/PM</InputLabel>
                                            <Select
                                                labelId="to-ampm-label"
                                                id="toAmPm"
                                                value={formik.values.toAmPm || 'AM'}
                                                onChange={(e) => handleDateTimeChange('to', undefined, undefined, e.target.value)}
                                                label="AM/PM"
                                            >
                                                <MenuItem value="AM">AM</MenuItem>
                                                <MenuItem value="PM">PM</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                {formik.touched.toDate && formik.errors.toDate && (
                                    <Typography size="sm" color="error" style={{ marginTop: 4, marginLeft: 14 }}>
                                        {formik.errors.toDate}
                                    </Typography>
                                )}
                                {formik.touched.toTime && formik.errors.toTime && (
                                    <Typography size="sm" color="error" style={{ marginTop: 4, marginLeft: 14 }}>
                                        {formik.errors.toTime}
                                    </Typography>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth variant="outlined" margin="dense">
                                    <InputLabel id="category-select-label">Category</InputLabel>
                                    <Select
                                        labelId="category-select-label"
                                        id="categoryId"
                                        name="categoryId"
                                        value={formik.values.categoryId}
                                        onChange={formik.handleChange}
                                        label="Category"
                                        error={formik.touched.categoryId && Boolean(formik.errors.categoryId)}
                                    >
                                        <MenuItem value="">
                                            <em>Select Category</em>
                                        </MenuItem>
                                        {categoryList.map((category) => (
                                            <MenuItem key={category._id} value={category._id}>
                                                {category.category}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {formik.touched.categoryId && formik.errors.categoryId && (
                                        <Typography size="sm" color="error" style={{ marginTop: 8, marginLeft: 14 }}>
                                            {formik.errors.categoryId}
                                        </Typography>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id="venue"
                                    name="venue"
                                    label="Venue"
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={formik.handleChange}
                                    value={formik.values.venue}
                                    error={formik.touched.venue && Boolean(formik.errors.venue)}
                                    helperText={formik.touched.venue && formik.errors.venue}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="locationLink"
                                    name="locationLink"
                                    label="Location Link"
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={formik.handleChange}
                                    value={formik.values.locationLink}
                                    error={formik.touched.locationLink && Boolean(formik.errors.locationLink)}
                                    helperText={formik.touched.locationLink ? formik.errors.locationLink : "Enter Google Maps link or any location URL"}
                                    placeholder="https://maps.google.com/..."
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="specialInstructions"
                                    name="specialInstructions"
                                    label="Special Instructions"
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    multiline
                                    rows={4}
                                    onChange={formik.handleChange}
                                    value={formik.values.specialInstructions}
                                    error={formik.touched.specialInstructions && Boolean(formik.errors.specialInstructions)}
                                    helperText={formik.touched.specialInstructions && formik.errors.specialInstructions}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth variant="outlined" margin="dense">
                                    <InputLabel id="status-select-label">Status</InputLabel>
                                    <Select
                                        labelId="status-select-label"
                                        id="status"
                                        name="status"
                                        value={formik.values.status}
                                        onChange={formik.handleChange}
                                        label="Status"
                                    >
                                        <MenuItem value="active">Active</MenuItem>
                                        <MenuItem value="inactive">Inactive</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit" color="primary" variant="contained">
                            {adminEvent._id ? 'Update' : 'Add'}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>

            {/* Delete Confirmation Dialog */}
            <Dialog open={deleteDialogOpen} onClose={handleDeleteCancel}>
                <DialogTitle>Delete Admin Event</DialogTitle>
                <DialogContent>
                    <MuiTypography>
                        Are you sure you want to delete this admin event? This action cannot be undone.
                    </MuiTypography>
                    {adminEventToDelete && (
                        <MuiTypography variant="body2" color="textSecondary" style={{ marginTop: 16 }}>
                            Event: {adminEventToDelete.eventName || 'N/A'}<br />
                            City: {adminEventToDelete.cityId?.city || adminEventToDelete.cityId || 'N/A'}<br />
                            Venue: {adminEventToDelete.venue || 'N/A'}
                        </MuiTypography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteCancel} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteConfirm} color="secondary" variant="contained" style={{ backgroundColor: '#d32f2f' }}>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

